export default "__VITE_ASSET__D4m0QH3o__"